// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://src` | (string & {});
};

/**
 * Body_auth:cookie.login
 */
export type BodyAuthCookieLogin = {
    /**
     * Grant Type
     */
    grant_type?: string | null;
    /**
     * Username
     */
    username: string;
    /**
     * Password
     */
    password: string;
    /**
     * Scope
     */
    scope?: string;
    /**
     * Client Id
     */
    client_id?: string | null;
    /**
     * Client Secret
     */
    client_secret?: string | null;
};

/**
 * Body_reset:forgot_password
 */
export type BodyResetForgotPassword = {
    /**
     * Email
     */
    email: string;
};

/**
 * Body_reset:reset_password
 */
export type BodyResetResetPassword = {
    /**
     * Token
     */
    token: string;
    /**
     * Password
     */
    password: string;
};

/**
 * Body_verify:request-token
 */
export type BodyVerifyRequestToken = {
    /**
     * Email
     */
    email: string;
};

/**
 * Body_verify:verify
 */
export type BodyVerifyVerify = {
    /**
     * Token
     */
    token: string;
};

/**
 * DocumentCreate
 */
export type DocumentCreate = {
    /**
     * Title
     */
    title: string;
    /**
     * Text
     */
    text: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
};

/**
 * DocumentRead
 */
export type DocumentRead = {
    /**
     * Title
     */
    title: string;
    /**
     * Text
     */
    text: string;
    /**
     * Id
     */
    id: number;
    /**
     * Public Id
     */
    public_id: string | null;
    /**
     * Word Count
     */
    word_count: number;
    /**
     * Text Modified At
     */
    text_modified_at: string;
    /**
     * Owners
     */
    owners: Array<string>;
    /**
     * Collaborators
     */
    collaborators: Array<string>;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Deleted
     */
    deleted?: string | null;
};

/**
 * DocumentReadPublic
 */
export type DocumentReadPublic = {
    /**
     * Title
     */
    title: string;
    /**
     * Text
     */
    text: string;
    /**
     * Public Id
     */
    public_id: string | null;
    /**
     * Word Count
     */
    word_count: number;
    /**
     * Text Modified At
     */
    text_modified_at: string;
    /**
     * Owners
     */
    owners: Array<string>;
    font: Font;
};

/**
 * DocumentUpdate
 */
export type DocumentUpdate = {
    /**
     * Title
     */
    title?: string;
    /**
     * Text
     */
    text?: string;
};

/**
 * ErrorModel
 */
export type ErrorModel = {
    /**
     * Detail
     */
    detail: string | {
        [key: string]: string;
    };
};

/**
 * Font
 */
export const Font = {
    SERIF: 'serif',
    SANS: 'sans',
    MONOSPACE: 'monospace'
} as const;

/**
 * Font
 */
export type Font = typeof Font[keyof typeof Font];

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * OAuth2AuthorizeResponse
 */
export type OAuth2AuthorizeResponse = {
    /**
     * Authorization Url
     */
    authorization_url: string;
};

/**
 * ShareSettingsUpdate
 */
export type ShareSettingsUpdate = {
    /**
     * Share
     */
    share: boolean;
};

/**
 * Theme
 */
export const Theme = {
    SYSTEM: 'system',
    LIGHT: 'light',
    DARK: 'dark'
} as const;

/**
 * Theme
 */
export type Theme = typeof Theme[keyof typeof Theme];

/**
 * UserCreatePublic
 */
export type UserCreatePublic = {
    /**
     * Name
     */
    name: string;
    /**
     * Avatar Color
     */
    avatar_color?: number;
    display_theme?: Theme;
    font?: Font;
    /**
     * Email
     */
    email: string;
    /**
     * Password
     */
    password: string;
};

/**
 * UserRead
 */
export type UserRead = {
    /**
     * Name
     */
    name: string;
    /**
     * Avatar Color
     */
    avatar_color?: number;
    display_theme?: Theme;
    font?: Font;
    /**
     * Id
     */
    id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Is Verified
     */
    is_verified: boolean;
};

/**
 * UserUpdate
 */
export type UserUpdate = {
    /**
     * Name
     */
    name?: string;
    /**
     * Avatar Color
     */
    avatar_color?: number;
    display_theme?: Theme;
    font?: Font;
    /**
     * Email
     */
    email?: string;
    /**
     * Password
     */
    password?: string;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
};

/**
 * VersionCreate
 */
export type VersionCreate = {
    /**
     * Title
     */
    title: string;
    /**
     * Document
     */
    document: number;
};

/**
 * VersionRead
 */
export type VersionRead = {
    /**
     * Title
     */
    title: string;
    /**
     * Id
     */
    id: number;
    /**
     * Public Id
     */
    public_id: string | null;
    /**
     * Text
     */
    text: string;
    /**
     * Word Count
     */
    word_count: number;
    /**
     * Document
     */
    document: number;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Text Modified At
     */
    text_modified_at: string;
    /**
     * Deleted
     */
    deleted?: string | null;
};

/**
 * VersionReadPublic
 */
export type VersionReadPublic = {
    /**
     * Title
     */
    title: string;
    /**
     * Public Id
     */
    public_id: string | null;
    /**
     * Text
     */
    text: string;
    /**
     * Word Count
     */
    word_count: number;
    /**
     * Text Modified At
     */
    text_modified_at: string;
    /**
     * Document
     */
    document: string;
    /**
     * User
     */
    user: string;
    font: Font;
};

/**
 * VersionUpdate
 */
export type VersionUpdate = {
    /**
     * Title
     */
    title: string;
};

export type AuthCookieLoginData = {
    body: BodyAuthCookieLogin;
    path?: never;
    query?: {
        next?: string;
    };
    url: '/auth/login';
};

export type AuthCookieLoginErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AuthCookieLoginError = AuthCookieLoginErrors[keyof AuthCookieLoginErrors];

export type AuthCookieLoginResponses = {
    /**
     * Successful Response
     */
    200: unknown;
    /**
     * No Content
     */
    204: void;
};

export type AuthCookieLoginResponse = AuthCookieLoginResponses[keyof AuthCookieLoginResponses];

export type AuthCookieLogoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/auth/logout';
};

export type AuthCookieLogoutErrors = {
    /**
     * Missing token or inactive user.
     */
    401: unknown;
};

export type AuthCookieLogoutResponses = {
    /**
     * Successful Response
     */
    200: unknown;
    /**
     * No Content
     */
    204: void;
};

export type AuthCookieLogoutResponse = AuthCookieLogoutResponses[keyof AuthCookieLogoutResponses];

export type VerifyRequestTokenData = {
    body: BodyVerifyRequestToken;
    path?: never;
    query?: never;
    url: '/auth/request-verify-token';
};

export type VerifyRequestTokenErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VerifyRequestTokenError = VerifyRequestTokenErrors[keyof VerifyRequestTokenErrors];

export type VerifyRequestTokenResponses = {
    /**
     * Successful Response
     */
    202: unknown;
};

export type VerifyVerifyData = {
    body: BodyVerifyVerify;
    path?: never;
    query?: never;
    url: '/auth/verify';
};

export type VerifyVerifyErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VerifyVerifyError = VerifyVerifyErrors[keyof VerifyVerifyErrors];

export type VerifyVerifyResponses = {
    /**
     * Successful Response
     */
    200: UserRead;
};

export type VerifyVerifyResponse = VerifyVerifyResponses[keyof VerifyVerifyResponses];

export type RegisterRegisterData = {
    body: UserCreatePublic;
    path?: never;
    query?: never;
    url: '/auth/register';
};

export type RegisterRegisterErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RegisterRegisterError = RegisterRegisterErrors[keyof RegisterRegisterErrors];

export type RegisterRegisterResponses = {
    /**
     * Successful Response
     */
    201: UserRead;
};

export type RegisterRegisterResponse = RegisterRegisterResponses[keyof RegisterRegisterResponses];

export type ResetForgotPasswordData = {
    body: BodyResetForgotPassword;
    path?: never;
    query?: never;
    url: '/auth/forgot-password';
};

export type ResetForgotPasswordErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ResetForgotPasswordError = ResetForgotPasswordErrors[keyof ResetForgotPasswordErrors];

export type ResetForgotPasswordResponses = {
    /**
     * Successful Response
     */
    202: unknown;
};

export type ResetResetPasswordData = {
    body: BodyResetResetPassword;
    path?: never;
    query?: never;
    url: '/auth/reset-password';
};

export type ResetResetPasswordErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ResetResetPasswordError = ResetResetPasswordErrors[keyof ResetResetPasswordErrors];

export type ResetResetPasswordResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OauthGoogleCookieAuthorizeData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Scopes
         */
        scopes?: Array<string>;
        next?: string;
    };
    url: '/auth/google/authorize';
};

export type OauthGoogleCookieAuthorizeErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OauthGoogleCookieAuthorizeError = OauthGoogleCookieAuthorizeErrors[keyof OauthGoogleCookieAuthorizeErrors];

export type OauthGoogleCookieAuthorizeResponses = {
    /**
     * Successful Response
     */
    200: OAuth2AuthorizeResponse;
};

export type OauthGoogleCookieAuthorizeResponse = OauthGoogleCookieAuthorizeResponses[keyof OauthGoogleCookieAuthorizeResponses];

export type OauthGoogleCookieCallbackData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Code
         */
        code?: string | null;
        /**
         * Code Verifier
         */
        code_verifier?: string | null;
        /**
         * State
         */
        state?: string | null;
        /**
         * Error
         */
        error?: string | null;
    };
    url: '/auth/google/callback';
};

export type OauthGoogleCookieCallbackErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OauthGoogleCookieCallbackError = OauthGoogleCookieCallbackErrors[keyof OauthGoogleCookieCallbackErrors];

export type OauthGoogleCookieCallbackResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UsersCurrentUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/auth/me';
};

export type UsersCurrentUserErrors = {
    /**
     * Missing token or inactive user.
     */
    401: unknown;
};

export type UsersCurrentUserResponses = {
    /**
     * Successful Response
     */
    200: UserRead;
};

export type UsersCurrentUserResponse = UsersCurrentUserResponses[keyof UsersCurrentUserResponses];

export type UsersPatchCurrentUserData = {
    body: UserUpdate;
    path?: never;
    query?: never;
    url: '/auth/me';
};

export type UsersPatchCurrentUserErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Missing token or inactive user.
     */
    401: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UsersPatchCurrentUserError = UsersPatchCurrentUserErrors[keyof UsersPatchCurrentUserErrors];

export type UsersPatchCurrentUserResponses = {
    /**
     * Successful Response
     */
    200: UserRead;
};

export type UsersPatchCurrentUserResponse = UsersPatchCurrentUserResponses[keyof UsersPatchCurrentUserResponses];

export type UsersDeleteUserData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: string;
    };
    query?: never;
    url: '/auth/{id}';
};

export type UsersDeleteUserErrors = {
    /**
     * Missing token or inactive user.
     */
    401: unknown;
    /**
     * Not a superuser.
     */
    403: unknown;
    /**
     * The user does not exist.
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UsersDeleteUserError = UsersDeleteUserErrors[keyof UsersDeleteUserErrors];

export type UsersDeleteUserResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type UsersDeleteUserResponse = UsersDeleteUserResponses[keyof UsersDeleteUserResponses];

export type UsersUserData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: string;
    };
    query?: never;
    url: '/auth/{id}';
};

export type UsersUserErrors = {
    /**
     * Missing token or inactive user.
     */
    401: unknown;
    /**
     * Not a superuser.
     */
    403: unknown;
    /**
     * The user does not exist.
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UsersUserError = UsersUserErrors[keyof UsersUserErrors];

export type UsersUserResponses = {
    /**
     * Successful Response
     */
    200: UserRead;
};

export type UsersUserResponse = UsersUserResponses[keyof UsersUserResponses];

export type UsersPatchUserData = {
    body: UserUpdate;
    path: {
        /**
         * Id
         */
        id: string;
    };
    query?: never;
    url: '/auth/{id}';
};

export type UsersPatchUserErrors = {
    /**
     * Bad Request
     */
    400: ErrorModel;
    /**
     * Missing token or inactive user.
     */
    401: unknown;
    /**
     * Not a superuser.
     */
    403: unknown;
    /**
     * The user does not exist.
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UsersPatchUserError = UsersPatchUserErrors[keyof UsersPatchUserErrors];

export type UsersPatchUserResponses = {
    /**
     * Successful Response
     */
    200: UserRead;
};

export type UsersPatchUserResponse = UsersPatchUserResponses[keyof UsersPatchUserResponses];

export type DocumentListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Skip
         */
        skip?: number;
        /**
         * Limit
         */
        limit?: number;
    };
    url: '/api/documents/';
};

export type DocumentListErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentListError = DocumentListErrors[keyof DocumentListErrors];

export type DocumentListResponses = {
    /**
     * Response Document List
     * Successful Response
     */
    200: Array<DocumentRead>;
};

export type DocumentListResponse = DocumentListResponses[keyof DocumentListResponses];

export type DocumentCreateData = {
    body: DocumentCreate;
    path?: never;
    query?: never;
    url: '/api/documents/';
};

export type DocumentCreateErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentCreateError = DocumentCreateErrors[keyof DocumentCreateErrors];

export type DocumentCreateResponses = {
    /**
     * Successful Response
     */
    201: DocumentRead;
};

export type DocumentCreateResponse = DocumentCreateResponses[keyof DocumentCreateResponses];

export type DocumentArchiveListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Skip
         */
        skip?: number;
        /**
         * Limit
         */
        limit?: number;
    };
    url: '/api/documents/archive/';
};

export type DocumentArchiveListErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentArchiveListError = DocumentArchiveListErrors[keyof DocumentArchiveListErrors];

export type DocumentArchiveListResponses = {
    /**
     * Response Document Archive List
     * Successful Response
     */
    200: Array<DocumentRead>;
};

export type DocumentArchiveListResponse = DocumentArchiveListResponses[keyof DocumentArchiveListResponses];

export type DocumentArchiveData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/documents/{id}/';
};

export type DocumentArchiveErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentArchiveError = DocumentArchiveErrors[keyof DocumentArchiveErrors];

export type DocumentArchiveResponses = {
    /**
     * Successful Response
     */
    200: DocumentRead;
};

export type DocumentArchiveResponse = DocumentArchiveResponses[keyof DocumentArchiveResponses];

export type DocumentReadData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/documents/{id}/';
};

export type DocumentReadErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentReadError = DocumentReadErrors[keyof DocumentReadErrors];

export type DocumentReadResponses = {
    /**
     * Successful Response
     */
    200: DocumentRead;
};

export type DocumentReadResponse = DocumentReadResponses[keyof DocumentReadResponses];

export type DocumentUpdateData = {
    body: DocumentUpdate;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/documents/{id}/';
};

export type DocumentUpdateErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentUpdateError = DocumentUpdateErrors[keyof DocumentUpdateErrors];

export type DocumentUpdateResponses = {
    /**
     * Successful Response
     */
    200: DocumentRead;
};

export type DocumentUpdateResponse = DocumentUpdateResponses[keyof DocumentUpdateResponses];

export type DocumentReadPublicData = {
    body?: never;
    path: {
        /**
         * Public Id
         */
        public_id: string;
    };
    query?: never;
    url: '/api/documents/public/{public_id}/';
};

export type DocumentReadPublicErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentReadPublicError = DocumentReadPublicErrors[keyof DocumentReadPublicErrors];

export type DocumentReadPublicResponses = {
    /**
     * Successful Response
     */
    200: DocumentReadPublic;
};

export type DocumentReadPublicResponse = DocumentReadPublicResponses[keyof DocumentReadPublicResponses];

export type DocumentShareData = {
    body: ShareSettingsUpdate;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/documents/{id}/share/';
};

export type DocumentShareErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentShareError = DocumentShareErrors[keyof DocumentShareErrors];

export type DocumentShareResponses = {
    /**
     * Successful Response
     */
    200: DocumentRead;
};

export type DocumentShareResponse = DocumentShareResponses[keyof DocumentShareResponses];

export type DocumentUnarchiveData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/documents/{id}/unarchive/';
};

export type DocumentUnarchiveErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DocumentUnarchiveError = DocumentUnarchiveErrors[keyof DocumentUnarchiveErrors];

export type DocumentUnarchiveResponses = {
    /**
     * Successful Response
     */
    200: DocumentRead;
};

export type DocumentUnarchiveResponse = DocumentUnarchiveResponses[keyof DocumentUnarchiveResponses];

export type VersionListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Skip
         */
        skip?: number;
        /**
         * Limit
         */
        limit?: number;
        /**
         * Document
         */
        document?: number | null;
    };
    url: '/api/versions/';
};

export type VersionListErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionListError = VersionListErrors[keyof VersionListErrors];

export type VersionListResponses = {
    /**
     * Response Version List
     * Successful Response
     */
    200: Array<VersionRead>;
};

export type VersionListResponse = VersionListResponses[keyof VersionListResponses];

export type VersionCreateData = {
    body: VersionCreate;
    path?: never;
    query?: never;
    url: '/api/versions/';
};

export type VersionCreateErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionCreateError = VersionCreateErrors[keyof VersionCreateErrors];

export type VersionCreateResponses = {
    /**
     * Successful Response
     */
    201: VersionRead;
};

export type VersionCreateResponse = VersionCreateResponses[keyof VersionCreateResponses];

export type VersionArchiveData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/versions/{id}/';
};

export type VersionArchiveErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionArchiveError = VersionArchiveErrors[keyof VersionArchiveErrors];

export type VersionArchiveResponses = {
    /**
     * Successful Response
     */
    200: VersionRead;
};

export type VersionArchiveResponse = VersionArchiveResponses[keyof VersionArchiveResponses];

export type VersionReadData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/versions/{id}/';
};

export type VersionReadErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionReadError = VersionReadErrors[keyof VersionReadErrors];

export type VersionReadResponses = {
    /**
     * Successful Response
     */
    200: VersionRead;
};

export type VersionReadResponse = VersionReadResponses[keyof VersionReadResponses];

export type VersionUpdateData = {
    body: VersionUpdate;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/versions/{id}/';
};

export type VersionUpdateErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionUpdateError = VersionUpdateErrors[keyof VersionUpdateErrors];

export type VersionUpdateResponses = {
    /**
     * Successful Response
     */
    200: VersionRead;
};

export type VersionUpdateResponse = VersionUpdateResponses[keyof VersionUpdateResponses];

export type VersionReadPublicData = {
    body?: never;
    path: {
        /**
         * Public Id
         */
        public_id: string;
    };
    query?: never;
    url: '/api/versions/public/{public_id}/';
};

export type VersionReadPublicErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionReadPublicError = VersionReadPublicErrors[keyof VersionReadPublicErrors];

export type VersionReadPublicResponses = {
    /**
     * Successful Response
     */
    200: VersionReadPublic;
};

export type VersionReadPublicResponse = VersionReadPublicResponses[keyof VersionReadPublicResponses];

export type VersionShareData = {
    body: ShareSettingsUpdate;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/versions/{id}/share/';
};

export type VersionShareErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionShareError = VersionShareErrors[keyof VersionShareErrors];

export type VersionShareResponses = {
    /**
     * Successful Response
     */
    200: VersionRead;
};

export type VersionShareResponse = VersionShareResponses[keyof VersionShareResponses];

export type VersionUnarchiveData = {
    body?: never;
    path: {
        /**
         * Id
         */
        id: number;
    };
    query?: never;
    url: '/api/versions/{id}/unarchive/';
};

export type VersionUnarchiveErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VersionUnarchiveError = VersionUnarchiveErrors[keyof VersionUnarchiveErrors];

export type VersionUnarchiveResponses = {
    /**
     * Successful Response
     */
    200: VersionRead;
};

export type VersionUnarchiveResponse = VersionUnarchiveResponses[keyof VersionUnarchiveResponses];

export type RedirectToStyleguideRootData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/styleguide';
};

export type RedirectToStyleguideRootResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type CatchAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/{path}';
};

export type CatchAllResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};
